export default __webpack_public_path__ + "static/silkserif-regular-526dd2bc093cf920f1d33b85490fd90d.woff2";